import { LOCAL_API_URL, http } from "../base";
  export async function set_password_sms(requestData) {
    console.log("set_password_sms", requestData);
    const response = await http.post(
      `/user/set_pwd_sms`,
      {
        phone: requestData.username,
        code: requestData.code,
        password: requestData.password,
      },
      {
        headers: { 'Content-Type': 'application/json',
         }

      });
      console.log(response.data);
      // 统一处理响应格式
      if (response.data==null || response.data.code !== 200) {
        throw new Error(response.data.message || '设置密码失败');
      }
      return response.data;
    }

    export async function change_password(requestData) {

      console.log("change_password", requestData);

      const response = await http.post(
           `/user/change_pwd`,
        {
          userName: requestData.username,
          oldPassword: requestData.oldPassword,
          newPassword: requestData.newPassword,
        },
        {
          headers: { 'Content-Type': 'application/json',
           }

        });
        console.log(response.data);
        // 统一处理响应格式
        if (response.data==null || response.data.code !== 200) {
          throw new Error(response.data.message || '修改密码失败');
        }
        return response.data;
      }

      export async function change_admin(requestData) {

        console.log("change_admin", requestData);

        const response = await http.post(
          `/tenant/change_admin`,
          {
            userName: requestData.username,
            code1: requestData.code1,
            newPhone: requestData.newPhone,
            code2: requestData.code2,
            newName: requestData.newName,
          },
          {
            headers: { 'Content-Type': 'application/json',
             }

          });
          console.log(response.data);
          // 统一处理响应格式
          if (response.data==null || response.data.code !== 200) {
            throw new Error(response.data.message || '变更管理员失败');
          }
          return response.data;
      }

      export async function change_phone(requestData) {

        console.log("change_phone", requestData);

        const response = await http.post(
          `${LOCAL_API_URL}/employees/change_phone`,
          {
            userName: requestData.username,
            code1: requestData.code1,
            newPhone: requestData.newPhone,
            code2: requestData.code2
          },
          {
            headers: { 'Content-Type': 'application/json',
             }

          });
          console.log(response.data);
          // 统一处理响应格式
          if (response.data==null || response.data.code !== 200) {
            throw new Error(response.data.message || '更换手机号失败');
          }
          return response.data;
      }
